module.exports = __webpack_public_path__ + "img/github.d7601356.svg";